import { render, staticRenderFns } from "./SelectFetchField.vue?vue&type=template&id=310fcbe8&scoped=true"
import script from "./SelectFetchField.vue?vue&type=script&lang=js"
export * from "./SelectFetchField.vue?vue&type=script&lang=js"
import style0 from "./SelectFetchField.vue?vue&type=style&index=0&id=310fcbe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310fcbe8",
  null
  
)

export default component.exports